import { Box, Card, Container, Grid, Image, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { PageTitle } from 'src/components/PageTitle';
import { useGetThemesQuery } from 'src/api/themes';
import { routes } from 'src/router/routes';
import { PageLoader } from 'src/components/PageLoader';

export const ThemesList: FC = () => {
  const { data: themes, isPending } = useGetThemesQuery();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  return (
    <Container size="lg" py="md">
      <Stack gap="lg">
        <PageTitle title="Themes" />

        {themes && themes.length > 0 ? (
          <Grid gutter="md">
            {themes.map((theme) => (
              <Grid.Col key={theme.id} span={{ base: 12, sm: 6, md: 4 }}>
                <Card
                  component={Link}
                  to={routes.theme.replace(':id', theme.id.toString())}
                  shadow="sm"
                  padding="lg"
                  radius="md"
                  withBorder
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Stack gap="md">
                    <Box>
                      <Image
                        src={theme.image}
                        alt={`Preview of ${theme.name}`}
                        radius="md"
                        height={200}
                        fallbackSrc="https://placehold.co/400x200?text=No+Image"
                      />
                    </Box>

                    <Stack gap="xs">
                      <Text size="lg" fw={600} lineClamp={1}>
                        {theme.name}
                      </Text>

                      <Text size="sm" c="dimmed">
                        Theme ID: {theme.theme_id}
                      </Text>

                      <Text size="sm" c="dimmed">
                        Dictionary ID: {theme.interaction_dictionary_id}
                      </Text>
                    </Stack>
                  </Stack>
                </Card>
              </Grid.Col>
            ))}
          </Grid>
        ) : (
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Stack gap="md" align="center">
              <Text size="lg" fw={600}>
                No themes found
              </Text>
              <Text c="dimmed">
                There are no themes available at the moment.
              </Text>
            </Stack>
          </Card>
        )}
      </Stack>
    </Container>
  );
};
